/* ==========================================================================
   Köp 2 (2026-09-27; 10 % på hela beställningen från 2026-10-12)
   1. "Visa villkor" / "Dölj villkor" fäller ut och ihop villkoren under raden ovanför köpknappen.
   2. "+ Lägg till" i förslagen (produktsidan och varukorgen). Varan läggs i med
      /cart/add.js genom window.nrKombiLaggTill (assets/nr-kombi.js), samma anrop som
      temats köpknapp gör, så Shopify skickar samma add_to_cart-händelse till Google.
      Lådan ritas om och öppnas som vid ett vanligt köp. På varukorgssidan laddas sidan om.
   3. Förslagen (runda 2): listor med data-k2-url fylls direkt efter sidladdningen med korten
      från sections/ha-kop2-recs (Shopifys Section Rendering API), och på nytt när lådan eller
      varukorgssidan ritas om. Produktsidan och varukorgen laddar därför lika snabbt som förut.
   Temat räknar aldrig rabatten; den dras av Shopify och syns när korgen ritas om.
   Laddas från snippets/ha-kop2 och snippets/cart-drawer; klicken fångas på document,
   så det spelar ingen roll att lådans innehåll byts ut.
   ========================================================================== */
(function () {
  'use strict';
  if (window.HaKop2) return;
  window.HaKop2 = true;

  /* 1. Villkoren */
  document.addEventListener('click', function (e) {
    var knapp = e.target.closest('[data-ha-k2-villkor]');
    if (!knapp) return;
    var mal = document.getElementById(knapp.getAttribute('aria-controls'));
    if (!mal) return;
    var oppen = knapp.getAttribute('aria-expanded') === 'true';
    knapp.setAttribute('aria-expanded', oppen ? 'false' : 'true');
    knapp.textContent = oppen ? 'Visa villkor' : 'Dölj villkor';
    mal.hidden = oppen;
  });

  /* 2. Lägg till */
  function visaFel(item, text) {
    var fel = item && item.querySelector('[data-ha-k2-err]');
    if (!fel) return;
    fel.textContent = text;
    fel.hidden = !text;
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ha-k2-select]');
    if (!sel) return;
    var item = sel.closest('[data-ha-k2-item]');
    var opt = sel.options[sel.selectedIndex];
    var pris = item && item.querySelector('[data-ha-k2-price]');
    if (pris && opt && opt.dataset.price) pris.textContent = opt.dataset.price;
    sel.classList.remove('is-invalid');
    visaFel(item, '');
  });

  function laggTill(id) {
    var paSidan = document.body.classList.contains('ha-t-cart');
    if (!paSidan && typeof window.nrKombiLaggTill === 'function') return window.nrKombiLaggTill(id, 1);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'fel');
        window.location.href = paSidan ? window.location.pathname : '/cart';
        return res;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ha-k2-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var item = btn.closest('[data-ha-k2-item]');
    var sel = item && item.querySelector('[data-ha-k2-select]');
    var id = btn.getAttribute('data-ha-k2-add') || (sel && sel.value);
    if (!id) {
      if (sel) {
        sel.classList.add('is-invalid');
        sel.focus();
      }
      visaFel(item, (sel && sel.options[0] ? sel.options[0].textContent : 'Välj storlek') + ' först.');
      return;
    }
    var text = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lägger till …';
    visaFel(item, '');
    laggTill(id)
      .then(function () {
        /* Lådan ritas om och den här knappen byts ut. Finns den kvar (produktsidan)
           visar vi kort att varan ligger i korgen. */
        btn.textContent = '✓ Tillagd';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = text;
        }, 2000);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = text;
        visaFel(item, (err && err.message && err.message !== 'fel' ? err.message : 'Det gick inte att lägga till varan.') + ' Försök igen eller öppna produkten.');
      });
  });

  /* 3. Förslagen hämtas i efterhand */
  function doljDubbletter(lista) {
    /* Varukorgens "Komplettera din utrustning" (snippets/ha-cart-recs) visar inte samma produkt igen. */
    var visade = {};
    lista.querySelectorAll('.ha-k2i__title').forEach(function (a) { visade[a.getAttribute('href')] = true; });
    document.querySelectorAll('.ha-cartrecs').forEach(function (box) {
      box.querySelectorAll('.ha-mini').forEach(function (a) { if (visade[a.getAttribute('href')]) a.remove(); });
      if (!box.querySelector('.ha-mini')) box.remove();
    });
  }

  function fyll(lista) {
    lista.setAttribute('data-k2-laddad', '');
    var antal = parseInt(lista.getAttribute('data-k2-antal'), 10) || 3;
    var url = lista.getAttribute('data-k2-url');
    var forhand = window.HaK2Forhand && window.HaK2Forhand[url];
    if (forhand) delete window.HaK2Forhand[url]; /* svaret används en gång; nästa gång hämtas nytt */
    /* 2026-10-07: högst 8 s väntan, sedan tas platshållarna bort (de blev annars stående som tomma fält). */
    var grans = new Promise(function (_, nej) { setTimeout(function () { nej(new Error('tidsgräns')); }, 8000); });
    Promise.race([forhand || fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.text();
    }), grans])
      .then(function (html) {
        if (!html) throw new Error('ingen sektion');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var kort = [].slice.call(doc.querySelectorAll('[data-ha-k2-item]'), 0, antal);
        if (!kort.length) throw new Error('inga förslag');
        lista.innerHTML = '';
        kort.forEach(function (k) { lista.appendChild(document.importNode(k, true)); });
        lista.classList.remove('is-laddar');
        lista.removeAttribute('aria-busy');
        doljDubbletter(lista);
      })
      .catch(function () {
        /* Inga förslag: produktsidans ruta försvinner helt, i varukorgen bara listan. */
        var box = lista.closest('.ha-k2x');
        (box || lista).remove();
      });
  }

  /* Listor i en stängd varukorgslåda väntar tills lådan öppnas (ingen hämtning i onödan på
     varje sida); lådan öppnas också när den ritats om efter ett köp. */
  function sok() {
    document.querySelectorAll('[data-k2-url]:not([data-k2-laddad])').forEach(function (lista) {
      var lada = lista.closest('cart-drawer');
      if (lada && !lada.classList.contains('active')) return;
      fyll(lista);
    });
  }
  var vantar = false;
  function snart() {
    if (vantar) return;
    vantar = true;
    requestAnimationFrame(function () {
      vantar = false;
      sok();
    });
  }
  new MutationObserver(snart).observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll('cart-drawer').forEach(function (lada) {
    new MutationObserver(snart).observe(lada, { attributes: true, attributeFilter: ['class'] });
  });
  sok();
})();
